import ProductCards from 'components/ProductCards/index';
import Banner from 'components/Banner';
import { data } from './mockdata';
import GradientText from 'components/GradientText';
import image from 'images/small-images-inside-text/Image.jpg';
import productsBanner from 'images/productsBanner.jpg';
import { LabelButton } from 'components/buttons/LabelButton/LabelButton';

const Products = () => {
    return (
        <>
            <Banner title="Our products" image={productsBanner} buttonText="VIEW PRODUCTS" />

            <section className="container">
                <div className="inner-container type-2">
                    <div className="main-text-container">
                        <LabelButton>agricultural solutions</LabelButton>
                        <GradientText>
                            We pride ourselves on providing a wide range of
                            <img src={image} alt="decor" />
                            <em>high-quality agricultural solutions</em> to meet your specific needs.
                        </GradientText>
                        <div className="offset-left-4 max-width-760">
                            <GradientText size="super-small">
                                Our product line is created to{' '}
                                <em>
                                    ensure sustainable growth <br />
                                    and increased yields.
                                </em>
                            </GradientText>
                        </div>
                    </div>
                </div>
            </section>

            {/* <ProductCards data={data} /> */}
            <ProductCards data={[data.organic_line, data.wuxal, data.fertiplant, data.unifer_x]} />
        </>
    );
};

export default Products;
